import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-portada-incripciones',
  standalone: true,
  imports: [],
  templateUrl: './portada-incripciones.component.html',
  styleUrl: './portada-incripciones.component.scss'
})
export class PortadaIncripcionesComponent {
  @Input() data: any;

  constructor(){

  }

  

}
